export const MANAGE_SUMMARY = 'MANAGE_SUMMARY';
export const MANAGE_ILBO = 'MANAGE_ILBO';
export const MANAGE_INOUT = 'MANAGE_INOUT';


// WEBPACK FOOTER //
// ./src/constants/manage.js